export const formatInputMoeda = (
  input = '',
  simbolo = 'R$',
  delimitadorCentesimal = '.',
  delimitadorDecimal = ','
) => {
  const negativo = !!String(input).match(/^R\$\s{1}-/g)
  input = input.replace(/\D/g, '') // Retira tudo o q não é numero
  input = input.length <= 3 ? input : input.replace(/^0+/g, '') // Retira os zeros se a length for <= 3
  input = input.length ? input : `0`
  input = input.length && input.length === 2 ? `0${input}` : input // Coloca um zero se o tamanho for 2
  input = input.length && input.length === 1 ? `00${input}` : input // Coloca dois zeros se o tamanho for 1
  input = input.replace(/(\d{1})(\d{2})$/, `$1${delimitadorDecimal}$2`) // coloca virgula antes dos ultimos 2 digitos
  while (
    input !== input.replace(/(\d{1,})(\d{3})/g, `$1${delimitadorCentesimal}$2`)
  ) {
    input = input.replace(/(\d{1,})(\d{3})/g, `$1${delimitadorCentesimal}$2`)
  }
  input = `${simbolo} ${
    negativo && input !== `0${delimitadorDecimal}00` ? '-' : ''
  }${input}`
  return input
}

export const numberToMoeda = (
  num,
  simbolo = 'R$',
  delimitadorCentesimal = '.',
  delimitadorDecimal = ','
) => {
  if (isNaN(num)) return 'NaN'
  num = parseFloat(num)
  const negativo = num < 0
  const numeroInteiro = parseInt(Math.abs(num))
  const numeroAbsoluto = Math.abs(numeroInteiro)
  let numerosDecimais =
    parseFloat(Math.abs(num) - numeroInteiro).toPrecision(2) * 100
  if (numerosDecimais < 10) numerosDecimais = `0${numerosDecimais}`
  return `${simbolo}${negativo ? ' - ' : ' '}${String(numeroAbsoluto).replace(
    /(\d)(?=(\d\d\d)+(?!\d))/g,
    `$1${delimitadorCentesimal}`
  )}${delimitadorDecimal}${numerosDecimais}`
}

export const inverseMoeda = (input = '') => {
  const matchNegativo = !!input.match(/-/g)
  return input
    .replace(/-/g, '')
    .replace(/(^R\$\s{1})(.*)/g, `$1${matchNegativo ? '' : '-'}$2`)
}

export const unformatMoeda = (input = '') => {
  input = '' + input
  if (!input || !input.length) return ''

  const matchNegativo = !!input.match(/-/g)
  input = input.replace(/\D/g, '')
  input = input.replace(/(\d{1})(\d{2})$/, `$1.$2`)
  return parseFloat(`${matchNegativo ? '-' : ''}${input}`)
}
